<template>
    <div class="footer">
        <div class="container">
            <p>Copyright ©2022：cnzyjy.org.cn 职业教育人才培养认证指导中心</p>
            <p>地 址：{{webConfigs.address}} 人力资源和社会保障局人力资源服务编号：B20211078954 </p>
            <p>技术支持：<a href="http://www.beijsci.com" target="_blank"> 职业教育人才培养认证指导中心</a>  &nbsp;&nbsp;<a href="http://beian.miit.gov.cn/" target="_blank">京ICP备16059467号-6</a> </p>
        </div>
    </div>
</template>
<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    webConfigs: Object,
  },
  data() {
    return {
      webConfig: {},
      global,
    };
  },
  mounted() {},
};
</script>

<style>
</style>
